module.exports = __webpack_public_path__ + "img/dash3.032982d8.png";